export default __webpack_public_path__ + "static/media/suitenupcias_5.bb604414.jpg";